<template>
  <div>
    <MainLayout>
      <TeammateList />
    </MainLayout>
  </div>
</template>

<script>
import MainLayout from '@/components/layouts/MainLayout/index.vue';
import TeammateList from './TeammateList.vue';

export default {
  components: {
    MainLayout,
    TeammateList,
  },
};
</script>
